import React, { createContext, useContext, ReactNode } from 'react';
import useAlert from '../hooks/useAlert';
import AlertModal from '../components/AlertModal';

// Create the context type with all the methods from useAlert
type AlertContextType = ReturnType<typeof useAlert>;

// Create the context with default empty values
const AlertContext = createContext<AlertContextType | undefined>(undefined);

// Provider component that will wrap the app
export const AlertProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const alertState = useAlert();
  
  return (
    <AlertContext.Provider value={alertState}>
      {children}
      {alertState.isVisible && (
        <AlertModal
          message={alertState.alertProps.message}
          type={alertState.alertProps.type}
          title={alertState.alertProps.title}
          onClose={alertState.hideAlert}
        />
      )}
    </AlertContext.Provider>
  );
};

// Custom hook to use the alert context
export const useAlertContext = () => {
  const context = useContext(AlertContext);
  if (context === undefined) {
    throw new Error('useAlertContext must be used within an AlertProvider');
  }
  return context;
};

export default AlertContext; 